import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService
} from '@fpx/core';
import { IHttpSuccessPayload, ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of } from 'rxjs';
import { BillRequest, BillRequestMaintanence } from './billRequest.model';
import { environment } from 'src/environments/environment';
@Injectable()
export class BillRequestService implements BaseFpxDataService<any> {
  constructor(private _httpProvider: HttpProviderService) { }
  isBillHistoryAvailable:boolean= true;
  create(payload: BillRequest): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setServerContext(environment.billpaymentsPublisher);
      httpRequest.setResource('/billRequest');
      let bodyContent = { "billRequest": payload };
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

  findByKey(key: BillRequest): FindByKeyFn<BillRequest> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/billRequest/{tranRef}');
      httpRequest.addPathParameter('tranRef', key.tranRef);
      httpRequest.setMethod('GET');
      httpRequest.setServerContext(environment.billpaymentsPublisher);
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.billrequest ?? null));

    };
  }

  modify(payload: BillRequest): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/billRequest/{tranRef}');
      httpRequest.addPathParameter('tranRef', payload.tranRef);
      httpRequest.setMethod('PUT');
      httpRequest.setServerContext(environment.billpaymentsPublisher);
      let bodyContent = { "billrequest": payload };
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }


  findAll(criteriaQuery: CriteriaQuery): FindAllFn<BillRequest[]> {
    return () => {
      criteriaQuery.addSortCriteria('paymentDate','desc','Date');
      const httpRequest = new HttpRequest();
      if (criteriaQuery.criteriaQuery( )?.FilterCriteria) {
       return this.createFilter(criteriaQuery.criteriaQuery().FilterCriteria[0]).pipe(
        map(
          (res: any) =>{
            if(res && res.body){
              this.isBillHistoryAvailable = true;
            }else{
              this.isBillHistoryAvailable = false;
            }
            return res?.body?.billRequest?res?.body?.billRequest:[]
          }

        )
      );
      } else {
        criteriaQuery.addSortCriteria('paymentDate','desc','Date');
        httpRequest.setCriteriaQuery(criteriaQuery);

        httpRequest.setResource('/billRequest');
        httpRequest.setMethod('GET');

        httpRequest.setServerContext(environment.billpaymentsPublisher);

        return this._httpProvider.invokeRestApi(httpRequest)
          .pipe(
            map(
              (res: IHttpSuccessPayload<BillRequestMaintanence>) =>
              {
                if(res && res.body){
                  this.isBillHistoryAvailable = true;
                }else{
                  this.isBillHistoryAvailable = false;
                }
                return res.body.billRequest
              }
            )
          );
      };
    }

  }

  createFilter(payload: any):Observable<BillRequest[]>{

      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setServerContext(environment.billpaymentsPublisher);
      httpRequest.setResource('/billRequest/query');
      let bodyContent = {
        "criteriaDetails": {
            "FilterExpression": "C1",
            "FilterCriteria": [
                {
                    "columnName": "paymentDate",
                    "columnType": "String",
                    "conditions": {
                        "searchType": "inRange",
                        "fromValue": payload.conditions.fromValue,
                        "toValue": payload.conditions.toValue
                    }
                }
            ]
        }
    }
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);

  }



  lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setResource('/billRequest');
      httpRequest.addQueryParameter('lookup', 1);
      const httpCriteria = new CriteriaQuery();
      httpCriteria.setPaginationCriteria('1', 10);
      httpCriteria.addFilterCritertia('text', 'String', 'startsWith', {
        searchText: key.searchText ?? '',
      });
      httpRequest.setCriteriaQuery(httpCriteria);

      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }
}
